import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PromoIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PromoIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4502 5.09009H20.4502C21.5548 5.09009 22.4502 5.98552 22.4502 7.09009V9.82458C22.4502 9.88708 22.4202 9.94579 22.3697 9.98247C20.4366 11.3841 20.4366 14.2648 22.3697 15.6665C22.4202 15.7031 22.4502 15.7618 22.4502 15.8243V18.5588C22.4502 19.6634 21.5548 20.5588 20.4502 20.5588H4.4502C3.34563 20.5588 2.4502 19.6634 2.4502 18.5588V15.8243C2.4502 15.7618 2.48014 15.7031 2.53074 15.6665C4.46375 14.2648 4.46375 11.3841 2.53074 9.98247C2.48014 9.94579 2.4502 9.88708 2.4502 9.82458V7.09009C2.4502 5.98552 3.34563 5.09009 4.4502 5.09009ZM16.1453 10.643C16.5423 10.2591 16.553 9.62606 16.1691 9.229C15.7853 8.83194 15.1522 8.82125 14.7551 9.20513L8.75513 15.0059C8.35807 15.3898 8.34738 16.0229 8.73125 16.4199C9.11513 16.817 9.74821 16.8277 10.1453 16.4438L16.1453 10.643ZM10.9497 10.1658C10.9497 10.8332 10.3901 11.3743 9.69971 11.3743C9.00935 11.3743 8.44971 10.8332 8.44971 10.1658C8.44971 9.49834 9.00935 8.95728 9.69971 8.95728C10.3901 8.95728 10.9497 9.49834 10.9497 10.1658ZM15.1504 16.7571C15.8407 16.7571 16.4004 16.216 16.4004 15.5486C16.4004 14.8812 15.8407 14.3401 15.1504 14.3401C14.46 14.3401 13.9004 14.8812 13.9004 15.5486C13.9004 16.216 14.46 16.7571 15.1504 16.7571Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PromoIcon;
